import {Injectable} from '@angular/core'
import {Messages} from '../model/message.model'

const defaultMessages: Messages = {
  addQuestion: 'Add a question',
  addSection: 'Add a section',
  addOption: 'Add option',
  addValidation: 'Answer validation',
  saved: 'Saved',
  duplicate: 'Duplicate',
  delete: 'Delete',
  minimize: 'Minimize',
  required: 'Required',
  documentValidation_allowOnlySpecificFileTypes: 'Allow only specific file types',
  documentValidation_filter_image: 'image',
  documentValidation_filter_spreadsheet: 'spreadsheet',
  documentValidation_filter_document: 'document',
  documentValidation_filter_presentation: 'presentation',
  documentValidation_filter_pdf: 'pdf',
  condition_closePopup: 'Close',
  condition_relatedQuestion: 'In question',
  condition_relatedSection: 'In section',
  condition_popupTitle: 'Display condition',
  condition_popupDesc: 'Pick an answer which must be selected to display this question',
  condition_noQuestion: 'No question with possibilities',
  placeholder_question_label: 'Question',
  placeholder_question_description: 'Description',
  placeholder_question_type: 'Type',
  placeholder_section_title: 'Section title',
  placeholder_section_description: 'Section description (optional)',
  placeholder_option_label: 'Option',
  placeholder_validation_MAX_LENGTH: 'Number of characters maximum',
  placeholder_validation_MIN_LENGTH: 'Number of characters minimum',
  placeholder_validation_EMAIL: 'Email',
  placeholder_validation_PHONE: 'Phone',
  placeholder_validation_REGEX: 'Pattern',
  placeholder_validation_number: 'Number',
  questionType_RADIO: 'Radio',
  questionType_SELECT: 'List',
  questionType_TEXT: 'Text',
  questionType_LONGTEXT: 'Longtext',
  questionType_CHECKBOX: 'Checkbox',
  questionType_DATE: 'Date',
  questionType_DOCUMENT: 'Document',
  questionType_LABEL: 'Title',
}

@Injectable()
export class MessageService {

  messages: Messages

  init(messages: Messages) {
    this.messages = {...defaultMessages, ...messages}
  }
}
